import type { BookConfig, FriendConfig } from '@/config';

export const roomDataOrigin = 'https://yukihime.dev';

export function resolveRoomAsset(asset: string | null) {
  if (asset === null || asset.length === 0) return null;
  if (/^https?:\/\//i.test(asset)) return asset;
  return `${roomDataOrigin}${asset.startsWith('/') ? asset : `/${asset}`}`;
}

export function randomItem<T>(items: readonly T[]) {
  return items[Math.floor(Math.random() * items.length)];
}

export function shuffledIds(items: readonly (BookConfig | FriendConfig)[]) {
  return items.map((item) => item.id).sort(() => Math.random() - 0.5);
}
